import React, { useContext } from 'react';
import { Icon } from 'semantic-ui-react';

import { FavoritesContext } from 'shared/context/FavoritesProvider';
import "./index.scss";
import { ArchivedRecordsContext } from 'shared/context/ArchivedRecordsProvider';

export const ProfileFavoriteIcon = ({
    id,
    type
}) => {
    const { onToggleFavorite, isInFavorites, isAddingFavorite, isRemovingFavorite } = useContext(FavoritesContext);
    const { isArchivedView } = useContext(ArchivedRecordsContext);
    return (
        <div className='ProfileHeader__iconsBox' onClick={() => {
            if (isArchivedView) return;
            onToggleFavorite({
                external_id: Number(id),
                favorite_type: type
            })
        }}>
            <div className='ProfileHeader__iconOverlay' />
                <Icon
                    link
                    name={"star"}
                    className={`ProfileFavoriteIcon ProfileFavoriteIcon--${isInFavorites({
                        external_id: Number(id),
                        favorite_type: type
                    }) ? 'yellow' : 'grey'}`}
                    loading={isAddingFavorite || isRemovingFavorite}
                    disabled={isAddingFavorite || isRemovingFavorite || isArchivedView}
                />
        </div>
    );
};
